import { useUser } from '@clerk/clerk-react'
import { Card, CodeInline } from '../components/ui'

export function SettingsPage() {
  const { user } = useUser()

  return (
    <>
      <div className="page-head">
        <div className="page-head__text">
          <h1>Settings</h1>
          <p className="muted">Your account, and what Detachly keeps.</p>
        </div>
      </div>

      <div className="stack">
        <Card>
          <div className="card__title">
            <h2>Account</h2>
          </div>
          <p className="muted">
            Signed in as{' '}
            <CodeInline>{user?.primaryEmailAddress?.emailAddress ?? 'unknown'}</CodeInline>. Use the
            avatar menu to change your profile or sign out.
          </p>
        </Card>

        <Card>
          <div className="card__title">
            <h2>Your data</h2>
          </div>
          <ul className="help-list">
            <li>
              Framer API keys are encrypted with AES-256-GCM and decrypted only while one of your
              jobs is running. They are never shown again after you paste them.
            </li>
            <li>
              Scan dumps and generated files live in private storage for 30 days, then they are
              deleted.
            </li>
            <li>Deleting a project removes its jobs, scans and files.</li>
          </ul>
        </Card>

        <Card>
          <div className="card__title">
            <h2>Billing</h2>
          </div>
          <p className="muted">
            Scanning, the Content Pack and the scaffold are free. Packages for AI rebuilds are not
            on sale yet — nothing here can charge you today.
          </p>
        </Card>
      </div>
    </>
  )
}
